import HistoricalTransactioninquiry from './historical-transaction-inquiry.vue'
export default HistoricalTransactioninquiry
